module.exports = __webpack_public_path__ + "static/img/SlideScreen01.9ea7d6c.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/Content/SlideScreen/SlideScreen01.png
// module id = ON39
// module chunks = 12